import { useMemo } from 'react'
import type { To } from 'react-router'

import { isUndefined } from '@hcr/utils'

import { Path } from '../../../../models'
import { to } from '../../../../utils'

interface UseBackNavigationPathOptions {
  holdingId: string | undefined
}

export const useBackNavigationPath = ({ holdingId }: UseBackNavigationPathOptions): To => {
  return useMemo((): To => {
    if (isUndefined(holdingId)) {
      return to(Path.Owner)
    }

    return to([Path.OwnerHoldingDetails, { holdingId }])
  }, [holdingId])
}
